import { createSlice } from "@reduxjs/toolkit";
import { getLastRate } from "./thunk";

const initialState = {
  lastRate: null,
  loading: false,
  error: null,
};

const ratingSlice = createSlice({
  name: "ratingSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL ADS
    builder
      .addCase(getLastRate.pending, (state) => {
        state.loading = true;
        state.lastRate = null;
        state.error = null;
      })
      .addCase(getLastRate.fulfilled, (state, action) => {
        state.loading = false;
        state.lastRate = action.payload;
      })
      .addCase(getLastRate.rejected, (state, action) => {
        state.loading = false;
        state.lastRate = null;
        state.error = action.error.message;
      });

    },
});

export default ratingSlice.reducer;